import React from "react";
// import data from "../json/Allproducts/Allproducts.json";
import Section1 from "../components/Allproducts/Section1";
import Section2 from "../components/Allproducts/Section2";
import { Outlet, useLocation } from "react-router-dom";

const Allproducts = () => {
  const location = useLocation();
  const isChild =
    location.pathname.includes("vedas") ||
    location.pathname.includes("xpertxpress") ||
    location.pathname.includes("xpertproof") ||
    location.pathname.includes("editlatex") ||
    location.pathname.includes("xpertreview") ||
    location.pathname.includes("xperttrack") ||
    location.pathname.includes("scholarlyxpert");

  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      {!isChild && (
        <>
          <Section1 />
          <Section2 />
        </>
      )}
      <Outlet />
    </div>
  );
};

export default Allproducts;
